import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import {Trans} from 'react-i18next';
import {NxCashInput} from '@nextbank/ui-components';
import {WaiveType} from '../../../../../../../shared/model/consolidate-loans';
import TableDataCell from '../../../../../../shared/table/cells/TableDataCell';
import styles from './WaiveTableRow.module.scss';

const COMMON_TRANS_PREFIX = 'COMMON';

interface Props {
  rowNumber: number;
  waiveType?: WaiveType;
  feeName: string;
  outstandingBalance: number;
  feeDefinitionId?: number;
  finalBalance: number;
  maxAmountInput?: number;
  waiveInput: number;
  onWaiveInputChange?: (value?: number | null, waiveType?: WaiveType, feeDefinitionId?: number) => void;
  isEditable?: boolean;
}

const WaiveTableRow = ({
                         rowNumber,
                         waiveType,
                         feeName,
                         finalBalance,
                         waiveInput,
                         outstandingBalance,
                         onWaiveInputChange,
                         isEditable = true,
                         feeDefinitionId
                       }: Props): React.ReactElement => {
  return (
    <TableRow className={styles.tableRow}>
      <TableDataCell data={rowNumber} />
      <TableDataCell data={feeName} />
      <TableDataCell data={<NxCashInput className={styles.fieldInput}
                                        label={<Trans>{`${COMMON_TRANS_PREFIX}.AMOUNT`}</Trans>}
                                        value={outstandingBalance}
                                        disabled
        // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        onChange={(): void => {
                                        }} />} />
      <TableDataCell data={<NxCashInput className={styles.fieldInput}
                                        label={<Trans>{`${COMMON_TRANS_PREFIX}.AMOUNT`}</Trans>}
                                        value={waiveInput}
                                        disabled={!isEditable}
                                        onChange={(value): void => onWaiveInputChange && onWaiveInputChange(value,
                                          waiveType, feeDefinitionId)} />} />
      <TableDataCell data={<NxCashInput className={styles.fieldInput}
                                        label={<Trans>{`${COMMON_TRANS_PREFIX}.AMOUNT`}</Trans>}
                                        value={finalBalance}
                                        disabled
        // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        onChange={(): void => {
                                        }} />} />
    </TableRow>
  );
};

export default WaiveTableRow;
